var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"u-info"},[_vm._t("default"),_c('span',{staticClass:"u-info__block"},[_vm._v(_vm._s(_vm.userId))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }